import _Sidemenu from '../_app/cuchillo/layout/Sidemenu';

export default class Sidemenu extends _Sidemenu {
  //static show(__call) {}
  //static hide(__call) {}
}
